import { toObject } from "../helpers/utils";
import {
  FORM_FIELD_DAMAGE_DETAILS,
  FORM_FIELD_ESTIMATE_AMOUNT,
  FORM_FIELD_JOB_SHEET_NUMBER,
} from "../constants/field";
import {
  ALL_STATUS,
  ALL_STATUS_TEXT,
  CLAIM_STATUS_CLOSED,
  CLAIM_STATUS_CLOSED_SLUG,
  CLAIM_STATUS_INITIATED,
  CLAIM_STATUS_INITIATED_SULG,
  CLAIM_STATUS_IN_PROGRESS,
  CLAIM_STATUS_IN_PROGRESS_SLUG,
  CLAIM_STATUS_REJECTED,
  CLAIM_STATUS_REJECTED_SLUG,
  CLAIM_STATUS_SETTLED,
  CLAIM_STATUS_SETTLED_SLUG,
  SLUG_DAMAGED_MOBILE,
  SLUG_ESTIMATE_MOBILE,
  SLUG_INVOICE_MOBILE,
  SLUG_OPEN,
  SLUG_REPAIRED_MOBILE,
  SLUG_REMARK,
} from "../constants/index";

export const defaultModalObject = {
  [SLUG_DAMAGED_MOBILE]: false,
  [SLUG_ESTIMATE_MOBILE]: false,
  [SLUG_INVOICE_MOBILE]: false,
  [SLUG_OPEN]: false,
  [SLUG_REPAIRED_MOBILE]: false,
  [SLUG_REMARK]: false
};

export const defaultPhotoObject = {
  [SLUG_DAMAGED_MOBILE]: "",
  [SLUG_ESTIMATE_MOBILE]: "",
  [SLUG_INVOICE_MOBILE]: "",
  [SLUG_REPAIRED_MOBILE]: "",
};

export const fields = [FORM_FIELD_DAMAGE_DETAILS, FORM_FIELD_ESTIMATE_AMOUNT, FORM_FIELD_JOB_SHEET_NUMBER];

export const formFields = toObject(fields);

export const options = {
  languages: [],
  status: [
    {
      title: ALL_STATUS_TEXT,
      value: ALL_STATUS,
    },
    {
      title: CLAIM_STATUS_INITIATED,
      value: CLAIM_STATUS_INITIATED_SULG,
    },
    {
      title: CLAIM_STATUS_IN_PROGRESS,
      value: CLAIM_STATUS_IN_PROGRESS_SLUG,
    },
    {
      title: CLAIM_STATUS_SETTLED,
      value: CLAIM_STATUS_SETTLED_SLUG,
    },
    {
      title: CLAIM_STATUS_REJECTED,
      value: CLAIM_STATUS_REJECTED_SLUG,
    },
    {
      title: CLAIM_STATUS_CLOSED,
      value: CLAIM_STATUS_CLOSED_SLUG,
    },
  ],
};

export const initialFormState = {
  ...formFields,
  hasError: false,
};

export const touchFieldsObject = toObject(fields, false);
